<template>
  <div>
    <RewardsComponent v-if="showRewardComponent" mobile />
  </div>
</template>

<script>
import useJwt from '@/auth/jwt/useJwt'
import RewardsComponent from './components/Index.vue'
import { localeChanged, localize } from 'vee-validate'
import { locales } from '@/libs/i18n/all-locales'

export default {
  name: 'RewardsMobile',
  components: {
    RewardsComponent,
  },
  data() {
    return {
      showRewardComponent: false,
    }
  },
  created() {
    // Önceki key'leri temizle
    useJwt.setToken(null)
    useJwt.setApiKey(null)

    const token = this.$cookies.get('token')
    const apiKey = this.$cookies.get('api-key') || 'zBqONnh0Osv0Q4EONtb74hGjhZKSzm'
    const locale = this.$cookies.get('locale')

    // Cookie'den dil geldiyse o dili ayarla
    if (locale) {
      const selectedLocale = locales.find(l => l.locale === locale)

      if (selectedLocale) {
        this.updateLocale(locale)
      } else {
        this.updateLocale('en')
      }
    }

    if (token && apiKey) {
      useJwt.setToken(token)
      useJwt.setApiKey(apiKey)

      setTimeout(() => {
        this.showRewardComponent = true
      }, 33)
    }
  },
  methods: {
    updateLocale(locale) {
      this.$i18n.locale = locale
      localize(locale)
      localeChanged()
      localStorage.setItem('locale', locale)

      if (locale === 'ar') {
        localStorage.setItem('isRTL', 'on')
      }
      this.$store.commit('appConfig/TOGGLE_RTL', locale === 'ar')

      this.updateLocaleFromServer(locale)
    },
    updateLocaleFromServer(lang) {
      if (lang) {
        useJwt.updateLanguage(lang)
      }
    },
  }
}
</script>
